/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { groupBy, mapValues, omit, sortBy } from 'lodash';
import { Observable, Subject, Subscription } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

import {
  LayoutUtilsService,
  MessageType,
} from '../../../../../../core/_base/crud';
import { User } from '../../../../../../core/auth';
import { AppState } from '../../../../../../core/reducers';
import {
  CSCActionFail,
  CSCActionSuccess,
  CSCharge,
  CSChargeActionTypes,
  CSChargesAdd,
  selectCSChargesByUid,
} from '../../../../../../core/ronex';

@Component({
  selector: 'kt-cscharges',
  templateUrl: './cscharges.component.html',
  styleUrls: ['./cscharges.component.scss'],
})
export class CschargesComponent implements OnInit, OnDestroy {
  @Input() user: User;

  new_charges: Array<CSCharge> = [];
  chargeForm: UntypedFormGroup;

  active_courier = 'ELTA';

  curr_mask = createNumberMask({
    prefix: '€ ',
    allowDecimal: true,
    decimalLimit: 2,
    //requireDecimal: true
  });

  kg_mask = createNumberMask({
    suffix: ' Kg',
    prefix: '',
    allowDecimal: true,
    decimalLimit: 1,
    //requireDecimal: true
  });

  charges$: Observable<any>;

  per_mask = createNumberMask({
    suffix: ' %',
    prefix: '',
    allowDecimal: true,
    decimalLimit: 2,
    //requireDecimal: true
  });

  min = 0;
  max = 150;
  wev = 0.1;

  serverError: Subject<any>;

  private subscriptions: Subscription[] = [];

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private chargeFB: UntypedFormBuilder,
    private store: Store<AppState>,
    private actions$: Actions,
    private ref: ChangeDetectorRef,
    private layoutUtilsService: LayoutUtilsService
  ) {}

  ngOnInit() {
    //console.log(this.chargeSettingsSubject.value);
    this.serverError = new Subject();

    const ss = this.actions$
      .pipe(
        ofType<CSCActionSuccess>(CSChargeActionTypes.CSCActionSuccess),
        tap(({ payload }) => {
          this.layoutUtilsService.showActionNotification(
            payload.result,
            MessageType.Update,
            5000,
            true,
            true
          );
          this.resetCharges();
        })
      )
      .subscribe();
    this.subscriptions.push(ss);

    const sf = this.actions$
      .pipe(
        ofType<CSCActionFail>(CSChargeActionTypes.CSCActionFail),
        tap(({ payload }) => {
          if (
            // eslint-disable-next-line no-prototype-builtins
            payload.result.hasOwnProperty('error') &&
            // eslint-disable-next-line no-prototype-builtins
            payload.result.error.hasOwnProperty('detail')
          ) {
            this.serverError.next(payload.result.error.detail);
          } else {
            this.serverError.next(
              'Συνέβη ένα σφάλμα με την αποθήκευση των δεδομένων. Παρακαλώ ξαναπροσπαθήστε.'
            );
          }
        })
      )
      .subscribe();
    this.subscriptions.push(sf);

    this.getCharges();

    /*    let nc : Charge = new Charge();
        nc.clear();
        nc.weight_start = 0.0;
        this.new_charges.push(nc);
    */
    this.createForm();
  }

  getCharges() {
    this.charges$ = this.store.pipe(
      select(selectCSChargesByUid(this.user.id)),
      //tap( res => this.uCharges = res ),
      map(res => res.filter(r => r.courier === this.active_courier)),
      map(res => {
        return mapValues(
          groupBy(
            sortBy(res, ach => ach.date_created).reverse(),
            'date_created'
          ),
          clist => clist.map(ch => omit(ch, 'date_created'))
        );
      })
    );
  }

  createForm() {
    const fgd: { [k: string]: any } = {
      static_charge: [''],
      per_kg_charge: [''],
      cod_charge: [''],
      weight_start: [''],
      weight_end: [''],
    };

    this.chargeForm = this.chargeFB.group(fgd);
    const k = (this.max - this.min) / 2 + this.min;
    this.chargeForm.get('weight_end').setValue(k.toFixed(0));
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sb => sb.unsubscribe());
  }

  addCharge() {
    const nc: CSCharge = new CSCharge();

    if (this.new_charges.length == 0) {
      nc.weight_start = 0;
    } else {
      nc.weight_start = this.min;
      nc.weight_end = parseFloat(this.chargeForm.controls.weight_end.value);
      this.min = nc.weight_end;
      this.new_charges[0].weight_start = this.min;
    }

    if (this.chargeForm.controls.static_charge.value) {
      nc.static_charge = parseFloat(
        this.chargeForm.controls.static_charge.value
          .replace('€ ', '')
          .replace(',', '')
      );
    }
    if (this.chargeForm.controls.per_kg_charge.value) {
      nc.per_kg_charge = parseFloat(
        this.chargeForm.controls.per_kg_charge.value
          .replace('€ ', '')
          .replace(',', '')
      );
    }
    if (this.chargeForm.controls.cod_charge.value) {
      nc.cod_charge = parseFloat(
        this.chargeForm.controls.cod_charge.value
          .replace('€ ', '')
          .replace(',', '')
      );
    }
    nc.courier = this.active_courier;
    nc.user = this.user.id;

    this.new_charges.push(nc);
    //Change array ref to triger onChanges in child comp.
    this.new_charges = this.new_charges.slice();

    this.createForm();
  }

  resetCharges() {
    this.new_charges = new Array<CSCharge>();
    this.min = 0;
    this.serverError.next(false);
  }

  setCourier(courier: string) {
    this.active_courier = courier;
    this.resetCharges();
    this.getCharges();
  }

  saveCharges() {
    this.serverError.next(false);
    this.store.dispatch(new CSChargesAdd({ cscharges: this.new_charges }));
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  nullSort() {}

  onAlertClose($event) {
    this.serverError.next(false);
  }
}
